import {ofType, combineEpics} from 'redux-observable';
import {map, mergeMap} from 'rxjs/operators';
import {logon, finishApi} from 'redux/appAction';
import {forkJoin} from 'rxjs';

import history from '../app/history';
import store from '../app/store';
import knowService from '../api/know/knowService';
import {
  RDX_EXP_SAVE_SUBMIT,
  updateExpData,
  updateExpDataDone,
  updateExpDataErr,
  RDX_EXP_DATA_UPDATE,
  RDX_EXP_QUESTIONNAIRE_FETCH,
  uploadExpCertificateDone,
  uploadExpCertificateErr,
  getExpDataDone,
  getExpDataErrorInfo,
  RDX_EXP_RESULT_FETCH,
  getExpResultDone,
  getExpResultErrorInfo,
  RDX_EXP_DOWNLOAD_FILE,
  downloadFileDone,
  downloadFile,
  // getExpResult,
} from '../redux/expAction';
import {getKnowNextStep} from '../redux/knowAction';
import {
  buildUpdateKnowRequest,
  convertGetKnowResponse,
  convertGetExpResponse,
  getKnowQuestionResult,
  converGetDocId,
  dataUrlTofile,
  checkResponseStatusCode,
  redirectToBack,
} from '../convertor/knowConvertor';
import commonConfig from '../config/commonConfig';

const initExpPageDataEpic = (action$) =>
  action$.pipe(
    ofType(RDX_EXP_QUESTIONNAIRE_FETCH),
    mergeMap((action) => {
      return forkJoin(
        knowService.getKnowData(action),
        knowService.getKnowResult({data: 'accreditation'}),
      ).pipe(
        map((responseList) => {
          if (responseList[0] && responseList[1]) {
            const statusCodeObj = checkResponseStatusCode(responseList);
            if (statusCodeObj.code === 200) {
              const data = convertGetExpResponse(responseList[0], responseList[1]);
              const docId = converGetDocId(responseList[1]);
              if (docId) {
                store.dispatch(downloadFile(docId));
              }
              return getExpDataDone({...data, docId});
            } else if (statusCodeObj.code === 403) {
              return logon('token');
            } else {
              // error response , go error flow
              history.push(`/mistake`);
              store.dispatch(finishApi());
              return getExpDataErrorInfo(statusCodeObj.errorList);
            }
          }
        }),
      );
    }),
  );

/**get experience result */
const downloadFileEpic = (action$) =>
  action$.pipe(
    ofType(RDX_EXP_DOWNLOAD_FILE),
    mergeMap((action) =>
      knowService.downloadFile(action).pipe(
        map((wResponse) => {
          if (wResponse && wResponse.status === 200) {
            const file = dataUrlTofile(wResponse);
            console.log('file', file);
            return downloadFileDone(file);
            // normal response, go normal flow
            // const data = convertGetKnowResponse(wResponse, action);
            // return getKnowDataDone(data);
          } else if (wResponse.status === 403) {
            return logon('token');
          } else {
            // error response , go error flow
            let errorInfo = '';
            if (wResponse.status === 500) {
              if (wResponse.response && wResponse.response.errorInfo) {
                errorInfo = wResponse.response.errorInfo;
              } else {
                errorInfo = [{code: wResponse.status}];
              }
            } else {
              errorInfo = [{code: wResponse.status}];
            }
            history.push('/mistake');
            store.dispatch(finishApi());
            return getExpDataErrorInfo(errorInfo);
          }
        }),
      ),
    ),
  );

/**get experience result */
const expResultDataEpic = (action$) =>
  action$.pipe(
    ofType(RDX_EXP_RESULT_FETCH),
    mergeMap((action) =>
      knowService.getKnowResult(action).pipe(
        map((wResponse) => {
          if (wResponse && wResponse.status === 200) {
            // normal response, go normal flow
            const data = convertGetKnowResponse(wResponse);
            if (action.params === 'thanks') {
              const knowResult = getKnowQuestionResult(data);
              return getExpResultDone(knowResult);
            } else {
              return getExpResultDone(data);
            }
          } else if (wResponse.status === 403) {
            return logon('token');
          } else {
            // error response , go error flow
            let errorInfo = '';
            if (wResponse.status === 500) {
              if (wResponse.response && wResponse.response.errorInfo) {
                errorInfo = wResponse.response.errorInfo;
              } else {
                errorInfo = [{code: wResponse.status}];
              }
            } else {
              errorInfo = [{code: wResponse.status}];
            }
            history.push('/mistake');
            store.dispatch(finishApi());
            return getExpResultErrorInfo(errorInfo);
          }
        }),
      ),
    ),
  );

/**save and exit or submit */
const updateExperienceEpic = (action$) =>
  action$.pipe(
    ofType(RDX_EXP_SAVE_SUBMIT),
    mergeMap((action) =>
      knowService.uploadCertificateFile(action.data.formData).pipe(
        map((wResponse) => {
          if (wResponse && wResponse.status === 201) {
            let updateParams = action.data.questionParams;
            updateParams.push(wResponse.response[0]);
            updateParams.push(wResponse.response[1]);
            store.dispatch(updateExpData(updateParams));
            return uploadExpCertificateDone(wResponse.response);
          } else if (wResponse.status === 403) {
            return logon('token');
          } else {
            let errorInfo = '';
            console.log('wResponse===========', wResponse);
            if (wResponse.status === 500) {
              if (wResponse.response && wResponse.response.errorInfo) {
                errorInfo = wResponse.response.errorInfo;
              } else {
                errorInfo = [{code: wResponse.status}];
              }
            } else {
              errorInfo = [{code: wResponse.status}];
            }
            return uploadExpCertificateErr(wResponse.status, errorInfo);
          }
        }),
      ),
    ),
  );

//update experience data
const expUpdateDataEpic = (action$) =>
  action$.pipe(
    ofType(RDX_EXP_DATA_UPDATE),
    mergeMap((action) =>
      knowService.updateKnowData(buildUpdateKnowRequest(action.data)).pipe(
        map((wResponse) => {
          console.log('wResponse=========', wResponse);
          if (wResponse && wResponse.status === 201) {
            if (redirectToBack(action.data)) {
              window.location.href = commonConfig.gsp.bankUrl;
            } else {
              store.dispatch(getKnowNextStep('accreditation'));
              return updateExpDataDone(wResponse.status);
            }
          } else if (wResponse.status === 403) {
            return logon('token');
          } else {
            // error response , go error flow
            let errorInfo = '';
            console.log('wResponse===========', wResponse);
            if (wResponse.status === 500) {
              if (wResponse.response && wResponse.response.errorInfo) {
                errorInfo = wResponse.response.errorInfo;
              } else {
                errorInfo = [{code: wResponse.status}];
                // history.push('/mistake');
              }
            } else {
              errorInfo = [{code: wResponse.status}];
              // history.push('/mistake');
            }
            return updateExpDataErr(wResponse.status, errorInfo);
          }
        }),
      ),
    ),
  );

const experienceEpic = combineEpics(
  initExpPageDataEpic,
  updateExperienceEpic,
  expUpdateDataEpic,
  expResultDataEpic,
  downloadFileEpic,
);

export default experienceEpic;
